var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:rating"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23 43.125C34.1147 43.125 43.125 34.1147 43.125 23C43.125 11.8853 34.1147 2.875 23 2.875C11.8853 2.875 2.875 11.8853 2.875 23C2.875 34.1147 11.8853 43.125 23 43.125Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.4795 9.58325L27.484 17.785L36.417 19.1346L29.9482 25.4676L31.4884 34.4999L23.4795 30.2433L15.4706 34.4999L17.0107 25.4676L10.542 19.1346L19.475 17.785L23.4795 9.58325Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.42e46ab2796939ab84f53aeee751c415.svg";
export { ForwardRef as ReactComponent };